export default __webpack_public_path__ + "static/low-fi-light-78feaec2a92c11a019b80afc04f93cef.png";